import { Session, useBillingInformationsByOrga } from '@app/api';
import { Button, useBoolModalState } from '@app/core';
import { useTranslation } from 'react-i18next';
import { SubmitButtonsLine } from 'components';
import { InvoicingModal } from './InvoicingModal';
import { BillingInformationVerificationModal } from './BillingInformationVerificationModal';

interface Props {
  className?: string;
  session?: Session;
}

export const InvoicingButtons = ({ className, session }: Props) => {
  const { t } = useTranslation();
  const [invoicingModalOpended, openInvoicingModal, closeInvoicingModal] =
    useBoolModalState();
  const [billingInfoModalOpended, openBillingInfoModal, closeBillingInfoModal] =
    useBoolModalState();

  const { data: billingInfo } = useBillingInformationsByOrga(
    session?.organizationId,
  );

  if (!session || !billingInfo) {
    return;
  }

  return (
    <>
      <SubmitButtonsLine className={className}>
        <Button
          type="button"
          color="green"
          onClick={() => openBillingInfoModal()}
          text={t('admin.billing.billingInfo.button')}
          small
        />
        <Button
          type="button"
          onClick={() => openInvoicingModal()}
          text={t('admin.billing.invoicing.button')}
          small
        />
      </SubmitButtonsLine>
      <InvoicingModal
        isOpen={invoicingModalOpended}
        onRequestClose={closeInvoicingModal}
        session={session}
        billingInformation={billingInfo}
      />
      <BillingInformationVerificationModal
        isOpen={billingInfoModalOpended}
        onRequestClose={closeBillingInfoModal}
        billingInformation={billingInfo}
      />
    </>
  );
};
